// NavCountContext.js
import React, { createContext, useContext, useState } from 'react';
import useApi from '../utils/useApi';  // Adjust the import path as needed

const NavCountContext = createContext();

export const NavCountProvider = ({ children }) => {
    const { getCount } = useApi();
    const [messageCount, setMessageCount] = useState(0);
    const [newDocs, setNewDocs] = useState();
    const [newDocsCount, setNewDocsCount] = useState();
    const [assignedDocs, setAssignedDocs] = useState();
    const [assignedDocsCount, setAssignedDocsCount] = useState();
    const [portalRequestCount, setPortalRequestCount] = useState();

    const refreshCounts = async () => {
        try {
            const response = await getCount();
            setMessageCount(response?.messageCount);
            setNewDocs(response?.newDocs);
            setAssignedDocs(response?.assignedDocs);
            setNewDocsCount(response?.count);
            setAssignedDocsCount(response?.inProgressCount);
            setPortalRequestCount(response?.newPortalRequestCount);
            return response;
        } catch (error) {
            console.error('Error refreshing counts:', error);
        }
    };

    return (
        <NavCountContext.Provider value={{
            messageCount,
            newDocs,
            newDocsCount,
            assignedDocs,
            assignedDocsCount,
            portalRequestCount,
            refreshCounts
        }}>
            {children}
        </NavCountContext.Provider>
    );
};

export const useNavCount = () => {
    const context = useContext(NavCountContext);
    if (!context) {
        throw new Error('useNavCount must be used within a NavCountProvider');
    }
    return context;
};
